import { useContextState } from '../../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: colors.color14,
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
      '& .break-w': { wordBreak: 'break-word' },
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 12px',
      gap: 0.5,
    },
    subtitle: {
      fontSize: '14px',
      color: colors.color22,
    },
    block: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '12px',
      padding: '0 12px',
      gap: 1,
      width: '100%',
    },
    blockTitle: {
      fontSize: '14px',
      color: colors.color13,
      fontWeight: '600',
    },
    approversContainer: {
      maxHeight: '280px',
      overflowY: 'auto',
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    approversList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    noData: {
      fontSize: '14px',
      color: 'c_grey.main',
      textAlign: 'center',
      padding: '16px 0',
    },
    actionsContainer: {
      display: 'flex',
      flexDirection: 'column',
      margin: '0 12px',
      marginTop: 'auto',
      padding: '12px 0',
      gap: 1.5,
      borderTop: `2px solid ${colors.color27}`,
    },
    generateButton: {
      borderRadius: '4px',
      fontWeight: 600,
      py: '10px',
    },
    dateItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 12px',
      backgroundColor: colors.sky,
    },
    approverItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '6px',
      backgroundColor: colors.sky,
      gap: 1,
    },
    approverItemText: {
      display: 'flex',
      flexDirection: 'column',
    },
    approverItemName: {
      fontSize: '14px',
      color: colors.color22,
      fontWeight: '500',
      lineHeight: 1.3,
    },
    approverItemEmail: {
      fontSize: '13px',
      color: 'c_grey.main',
      lineHeight: 1.3,
    },
    approverIcon: {
      fontSize: '28px',
      color: 'c_grey.main',
      display: 'flex',
      alignItems: 'center',
      '& .MuiSvgIcon-root': { fontSize: 'inherit' },
    },
  }
}
